import { useEffect } from 'react';
import { select } from 'd3';

const BAR_SLOT_RATIO = 0.7; // доля шага категории, занятая барами
const MIN_BAR_WIDTH = 1;

// Ширина слота категории по point-шкале
function getSlotWidth(x, categories) {
  if (typeof x.step === 'function') {
    return x.step();
  }
  if (categories.length > 1) {
    return Math.abs(x(categories[1]) - x(categories[0]));
  }
  return 0;
}

function buildBars({
  group, x, y, barTraces, categories, isStack
}) {
  group.selectAll('*').remove();

  const slotWidth = getSlotWidth(x, categories);
  const baseY = y(0);

  if (isStack) {
    const totalWidth = Math.max(MIN_BAR_WIDTH, slotWidth * BAR_SLOT_RATIO);

    categories.forEach((category, catIndex) => {
      const centerX = x(category);
      if (centerX === undefined) {
        return;
      }
      let cumulative = 0;

      barTraces.forEach((trace) => {
        const value = Number(trace.y[catIndex]);
        if (!Number.isFinite(value)) {
          return;
        }
        const bottom = y(cumulative);
        const top = y(cumulative + value);
        cumulative += value;

        group
          .append('rect')
          .attr('x', centerX - totalWidth / 2)
          .attr('y', Math.min(top, bottom))
          .attr('width', totalWidth)
          .attr('height', Math.abs(bottom - top))
          .attr('fill', trace.color);
      });
    });
    return;
  }

  // grouped: слот делится между бар-трейсами
  const groupCount = barTraces.length || 1;
  const groupWidth = Math.max(MIN_BAR_WIDTH, slotWidth * BAR_SLOT_RATIO);
  const barWidth = Math.max(MIN_BAR_WIDTH, groupWidth / groupCount);

  barTraces.forEach((trace, traceIndex) => {
    categories.forEach((category, catIndex) => {
      const centerX = x(category);
      if (centerX === undefined) {
        return;
      }
      const value = Number(trace.y[catIndex]);
      if (!Number.isFinite(value)) {
        return;
      }
      const top = y(value);
      const startX = centerX - groupWidth / 2 + traceIndex * barWidth;

      group
        .append('rect')
        .attr('x', startX)
        .attr('y', Math.min(top, baseY))
        .attr('width', barWidth)
        .attr('height', Math.abs(baseY - top))
        .attr('fill', trace.color);
    });
  });
}

function useBars(groupRef, options) {
  const {
    chartParams: {
      x, y
    },
    barTraces,
    categories,
    barLayout
  } = options;

  const isStack = barLayout?.mode === 'STACK';

  useEffect(() => {
    const group = groupRef.current ? select(groupRef.current) : null;
    if (!group) {
      return;
    }

    if (!barTraces?.length || !categories?.length) {
      group.selectAll('*').remove();
      return;
    }

    buildBars({
      group, x, y, barTraces, categories, isStack
    });
  }, [groupRef, x, y, barTraces, categories, isStack]);
}

export default useBars;
